import React from "react"
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import classes from "./Settings.module.css"
import { Link } from "react-router-dom";
import useCurrentUser from '../../hooks/useCurrentUser'

function AutoEmails({autoEmails, handleCheckUpdate, setAutoEmails}) {
    const user = useCurrentUser()
    const isOwner = (
        user.account_type === 'gym' ||
        (user.account_type === 'trainer' && parseInt(user.gym_id) === 0)
    )
    return (
        <Card className={`${classes.cardWidth} mb-5 shadow px-5`}>
            <Card.Body>
                <h4>Client Automated Email Settings</h4>
                <hr class="mt-1" />
                <div className="mb-3"> 
                {isOwner&&
                    <Button 
                        size="sm" 
                        variant="outline-primary" 
                        as={Link} 
                        to="/customization-dashboard?tab=email_customization"
                    >
                        Customize Client Welcome Email
                    </Button>
                }
                </div>
                {autoEmails && Object.entries(autoEmails).map(([name, value]) => {

                    let checked;
                    let message;
                    let dbField;

                    let displayName = name.split("_").join(" ")


                    switch (name) {
                        case "workout_update":
                            dbField = "email_workout"
                            break
                        case "nutrition_update":
                            dbField = "email_diet"
                            break
                        case "task_update":
                            dbField = "email_task"
                            break
                        case "schedule_update":
                            dbField = "emailScheduleUpdates"
                            break
                        case "chat_message":
                            dbField = "emailMessagesToClient"
                            break;
                        default:
                            console.log("dbfield auto emails incorrect")
                    }                                    
                    if (name === "chat_message") {
                        message = "Auto-email client the message."
                    } else {
                        message = "Auto-email clients when updated."
                    }


                    if (value == "1" || value === true) {
                        checked = true
                    } else {
                        checked = false;
                    }

                    if (autoEmails) {
                        return (
                            <Row key={name} className="d-flex align-items-center justify-content-center mb-3">
                                <Col >
                                    <div className="d-flex align-items-center" style={{ textTransform: "capitalize" }}>
                                        {displayName}
                                    </div>
                                </Col>
                                <Col >
                                        <Form.Group className="mb-0" controlId={"client" + name}>
                                            <Form.Check  name={name} label={message} onChange={(e) => {
                                                let name = e.target.name
                                                let currCheck = e.target.checked
                                                setAutoEmails(prev => ({ ...prev, [name]: currCheck }))
                                                handleCheckUpdate(name, currCheck, "automated_emails", dbField)
                                            }}

                                                checked={checked} type="checkbox" className="custom-control custom-checkbox" >
                                            </Form.Check >
                                        </Form.Group>
                                </Col>
                            </Row>
                        )
                    }
                })}


            </Card.Body>

        </Card>
    )
}

export default AutoEmails